import config from "@/utils/Config";
import {get, post } from "@/utils/request";

export function save(params = {}) {
    return post(config.BASE_URL, config.saveFriendLinkUrl, params)
}

export function getFriendList(params = {}) {
    return get(config.BASE_URL, config.getFriendListUrl, params)
}

export function getFriendListByPage(params = {}) {
    return post(config.BASE_URL, config.getFriendListByPageUrl, params)
}

export function delFriend(params = { id: id }) {
    return post(config.BASE_URL, config.delFriendUrl, params)
}